export default __webpack_public_path__ + "static/media/Dairy & Bread.d29ec2a0.png";